module.exports = __webpack_public_path__ + "static/media/ic-success.c4e163b2.svg";